import { render, staticRenderFns } from "./NoSliderHero.vue?vue&type=template&id=cbbc522e&scoped=true&"
import script from "./NoSliderHero.vue?vue&type=script&lang=js&"
export * from "./NoSliderHero.vue?vue&type=script&lang=js&"
import style0 from "./NoSliderHero.vue?vue&type=style&index=0&id=cbbc522e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbc522e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,BreadCrumbs: require('/vercel/path0/components/general/BreadCrumbs.vue').default,ArrowLink: require('/vercel/path0/components/general/ArrowLink.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default,Scrolly: require('/vercel/path0/components/icons/Scrolly.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
